import type { Variants } from "framer-motion";
export const AnimationVariants: Record<string, Variants> = Object.freeze({
	StaggerContainer: {
		hidden: {
			transition: {
				staggerChildren: 0.01,
				staggerDirection: -1,
				when: "afterChildren",
			},
		},
		show: {
			transition: {
				staggerChildren: 0.04,
				staggerDirection: 1,
				when: "beforeChildren",
			},
		},
	},
	StaggerItem: {
		hidden: {
			opacity: 0,
			// scale: 1,
			transition: { type: "linear" },
		},
		show: {
			opacity: 1,
			// scale: [0.95, 1],
			transition: { type: "linear" },
		},
	},
});
